import { Injectable } from "@angular/core";
import { FetchStatusSelector } from "@obg/ngrx-utils";

import { CoreState } from "../../../state";

import { ACTION_PREFIX } from "./multi-deposit-limit.action";
import { MultiDepositLimits, MultiDepositLimitState } from "./multi-deposit-limit.model";

/**
 * @deprecated [fabric-deprecated] - Use MultiDepositLimitService from app-responsible-gaming instead
 */
@Injectable({
	providedIn: "root",
})
export class MultiDepositLimitSelector {
	isBusy() {
		return (state: CoreState): boolean => FetchStatusSelector.isBusy(ACTION_PREFIX)(state);
	}

	/**
	 * @deprecated [fabric-deprecated] - Use ResponsibleGamingAppCommand.GetMultiDepositLimits instead
	 */
	get() {
		return (state: CoreState): MultiDepositLimits | undefined => state.multiDepositLimit.multiDepositLimits;
	}

	/**
	 * @deprecated [fabric-deprecated] - Use ResponsibleGamingAppCommand.GetMultiDepositLimits instead
	 */
	getState() {
		return (state: CoreState): MultiDepositLimitState => state.multiDepositLimit;
	}
}
